import React from 'react'

import {Segment,Dimmer,Loader} from 'semantic-ui-react'

const ConnectionError = () => {
    return (
          <Segment style={{height:"100%"}}>
            <Dimmer active inverted>
              <Loader indeterminate inverted size='big'>Återansluter till server</Loader>
            </Dimmer>
          </Segment>
    )
} 


export default ConnectionError;










